/** @jsxImportSource @emotion/react */
import { Paper as MuiPaper } from '@mui/material';
import { Accordion as ZipAccordion } from '@zip/business-components';
import { FC, ReactNode } from 'react';
import * as styles from './SetupAccordion.styles';
import { SetupAccordionProps } from './SetupAccordionProps';

const SetupAccordion: FC<SetupAccordionProps> = ({
  summary,
  defaultExpanded,
  children,
}) => {
  const content = {
    summary,
    defaultExpanded,
    details: children as ReactNode,
  };
  return (
    <MuiPaper css={[styles.paper, styles.zipAccordion]} elevation={0}>
      <ZipAccordion content={[content]} />
    </MuiPaper>
  );
};
export default SetupAccordion;
